import { useState } from "react";
import { Section, Chapter, Reveal } from "./Section";
import WarfareRegistration from "./WarfareRegistration";
import { Shield, Eye, Cross, BookOpen, ClipboardList } from "lucide-react";

const PILLARS = [
  [Shield, "Recognizing spiritual opposition"],
  [Eye, "Growing in discernment & wisdom"],
  [Cross, "Understanding spiritual authority"],
  [BookOpen, "Standing firmly in faith & prayer"],
];

export default function Warfare() {
  const [regOpen, setRegOpen] = useState(false);
  return (
    <Section id="warfare" testid="warfare-section">
      <div className="grid lg:grid-cols-12 gap-14 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative group">
            <div aria-hidden className="absolute -inset-4 rounded-[2rem] bg-red-600/15 blur-2xl group-hover:bg-red-600/25 transition-all duration-500" />
            <div className="relative overflow-hidden rounded-[1.75rem] border border-red-500/30 shadow-[0_0_60px_rgba(239,68,68,0.15)] transition-transform duration-700 group-hover:scale-[1.02]">
              <img src="/assets/warfare-poster.jpeg" alt="Spiritual Warfare Classes with Prophet Terrell Turner"
                data-testid="warfare-poster" className="w-full object-cover" />
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <span data-testid="warfare-badge" className="inline-flex items-center gap-2.5 mb-6 bg-red-500/10 text-red-200 border border-red-500/40 px-4 py-2 rounded-full text-sm font-semibold font-mono uppercase tracking-widest">
            <span className="h-1.5 w-1.5 rounded-full bg-red-400 animate-pulse-dot" />
            Now Registering — Six-Week Intensive
          </span>
          <Chapter number="03" label="Spiritual Warfare Classes" testid="warfare-chapter"
            title={<>Equipped for <span className="text-crimson-gold">the Battle</span></>}
            sub="Spiritual warfare requires more than emotion — it requires biblical understanding, spiritual discernment, discipline, and the proper application of Kingdom principles." />

          <Reveal delay={0.12} className="mt-8 glass rounded-2xl px-6 py-5">
            <p className="font-display text-lg font-bold text-white">Tuesdays, November 3 – December 8, 2026</p>
            <p className="mt-1 text-base text-slate-300">7:00 PM Eastern · Live on Zoom · Your Zoom link is sent after registration</p>
          </Reveal>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {PILLARS.map(([Icon, text], i) => (
              <Reveal key={text} delay={0.06 * i} className="flex items-center gap-3 text-base font-medium text-slate-200">
                <Icon size={18} className="shrink-0 text-red-400" />
                <span>{text}</span>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.18} className="mt-8">
            <button data-testid="warfare-registration-btn" onClick={() => setRegOpen(true)}
              className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-amber-400 to-red-500 text-white text-base font-bold uppercase tracking-[0.12em] shadow-[0_10px_35px_-10px_rgba(239,68,68,0.6)] hover:brightness-110 hover:scale-[1.03] active:scale-95 transition-all duration-300">
              <ClipboardList size={18} /> Register for the Class
            </button>
          </Reveal>
        </div>
      </div>
      <WarfareRegistration open={regOpen} onClose={() => setRegOpen(false)} />
    </Section>
  );
}
